export default __webpack_public_path__ + "static/media/cx_cover_c30s.24627dfe.jpg";